import './Footer.scss';

import { InfoOutlined, Instagram, Twitter } from '@mui/icons-material';
import { Chip } from '@mui/material';
import classNames from 'classnames';
import {
  ModalAddContent,
  ModalCreateTypes,
} from 'primary/Components/User/ModalAddContent';
import { useTranslate } from 'primary/hooks/useTranslate';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { UnpyLogo } from '../Components/UnpyLogo/UnpyLogo';
import { routesConfig } from '../Configs/Routes.config';
import { useBooleanToggle } from '../hooks/useBooleanToggle';
import { useContextDependency } from '../hooks/useContextDependency';

export const Footer = () => {
  const { authRepository } = useContextDependency();
  const t = useTranslate();
  const [openModalType, setOpenModalType] = useState<ModalCreateTypes | undefined>();
  const [isOpen, , openModal, closeModal] = useBooleanToggle();

  const handleOpenModalCreate = (type: ModalCreateTypes) => {
    if (authRepository?.currentUser) {
      setOpenModalType(type);
      openModal();
    } else {
      authRepository.login(
        `${window.location.origin}${window.location.pathname}${
          type === 'EVENT' ? '?createEvent=true' : '?createStructure=true'
        }`,
      );
    }
  };

  return (
    <footer className={classNames('footer')}>
      <div className={'-collapseBarButton'}></div>
      <div className={classNames('-containerCollapse')}>
        <div className={classNames('footer__container')}>
          <div className={'-col -colLogo'}>
            <UnpyLogo size={'bigger'} className={'footer__logo'} />
            <Chip
              size={'small'}
              color={'secondary'}
              className={classNames('-tag')}
              style={{
                textAlign: 'center',
                backgroundColor: '#151515',
                fontSize: '12px',
              }}
              label={'Bêta'}
            />
          </div>
          <div className={'-col -colPlanSite'}>
            <div className={'-rowPlanSite'}>
              <div className={'-planSite__section'}>
                <div className={'-planSite__section-title'}>
                  <h5>{t('footer.sections.mercato')}</h5>
                </div>
                <Link
                  className={'-planSite__section-link'}
                  to={routesConfig.mercatoSubPath.mercatoPlayer.to()}
                >
                  <span>{t('footer.sections.mercatoPlayer')}</span>
                </Link>
                <Link
                  className={'-planSite__section-link'}
                  to={routesConfig.mercatoSubPath.mercatoStructure.to()}
                >
                  <span>{t('footer.sections.mercatoStructure')}</span>
                </Link>
                <div
                  className={'-planSite__section-link'}
                  onClick={() => handleOpenModalCreate('STRUCTURE')}
                >
                  <span>{t('footer.sections.createStructure')}</span>
                </div>
              </div>
              <div className={'-planSite__section'}>
                <div className={'-planSite__section-title'}>
                  <h5>{t('footer.sections.events')}</h5>
                </div>
                <Link className={'-planSite__section-link'} to={routesConfig.events.to()}>
                  <span>{t('footer.sections.eventsSearch')}</span>
                </Link>
                <div
                  className={'-planSite__section-link'}
                  onClick={() => handleOpenModalCreate('EVENT')}
                >
                  <span>{t('footer.sections.createEvent')}</span>
                </div>
              </div>
              <div className={'-planSite__section'}>
                <h5 className={'-planSite__section-title'}>
                  {t('footer.sections.userMenu.title')}
                </h5>
                {!!authRepository?.currentUser && (
                  <>
                    <Link
                      className={'-planSite__section-link'}
                      to={routesConfig.parametersUser.to()}
                    >
                      <span>{t('footer.sections.userMenu.loggedIn.parametres')}</span>
                    </Link>
                    <Link
                      className={'-planSite__section-link'}
                      to={routesConfig.parametersUser.to()}
                    >
                      <span>{t('topbar.menuConnected.label.parameters')}</span>
                    </Link>
                    <Link
                      className={'-planSite__section-link'}
                      to={routesConfig.mercatoUserProfil.to(
                        authRepository?.currentUser.userProfil.id,
                      )}
                    >
                      <span>{t('topbar.menuConnected.label.myProfil')}</span>
                    </Link>
                    <Link
                      className={'-planSite__section-link'}
                      to={routesConfig.relationPage.to()}
                    >
                      <span>{t('topbar.menuConnected.label.relations')}</span>
                    </Link>
                    <Link
                      className={'-planSite__section-link'}
                      to={routesConfig.myStructures.to()}
                    >
                      <span>{t('topbar.menuConnected.label.myStructures')}</span>
                    </Link>
                    <Link
                      className={'-planSite__section-link'}
                      to={routesConfig.myEvents.to()}
                    >
                      <span>{t('topbar.menuConnected.label.myEvents')}</span>
                    </Link>
                    <Link
                      className={'-planSite__section-link'}
                      to={routesConfig.activities.to()}
                    >
                      <span>{t('topbar.menuConnected.label.activities')}</span>
                    </Link>
                  </>
                )}
                {!authRepository?.currentUser && (
                  <>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <div
                      className={'-planSite__section-link'}
                      onClick={() => authRepository.login()}
                    >
                      <span>{t('footer.sections.userMenu.loggedOut.toConnect')}</span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className={'-col -colSocialLinks'}>
            <h4>
              Rejoignez-nous - Unpy © <br />
            </h4>
            <div className={'-socialsLink'}>
              <a
                target="_blank"
                href={'https://twitter.com/Unpy__'}
                rel="noreferrer"
                title={'Twitter unpy'}
              >
                <Twitter />
              </a>
              <div className={'dot'}></div>
              <a
                target="_blank"
                href={'https://www.instagram.com/unpy.gg/'}
                rel="noreferrer"
                title={'Instagram unpy'}
              >
                <Instagram />
              </a>
            </div>
            <a
              className={'-btnHelpCenter'}
              href={'https://support.unpy.fr'}
              rel="noreferrer"
              target="_blank"
              title={"Centre d'aide Unpy"}
            >
              <InfoOutlined />
              Centre d'aide
            </a>
          </div>
        </div>
      </div>
      {openModalType && (
        <ModalAddContent
          isOpen={isOpen}
          handleClose={closeModal}
          modalCreateType={openModalType}
        />
      )}
    </footer>
  );
};
